import { fetchApi } from '../../../lib/fetchApi';
import { SendEmailClaimDto, LoadDocumentFollowUpReplyDto, ClaimFollowUpItemDto } from '../types';

const BASE_URL = "/claimFollowUp"

export const sendEmailClaim = async (body: SendEmailClaimDto): Promise<void> => {
    const formData = new FormData();

    if (body.claimComment) {
        formData.append("ClaimComment", body.claimComment);
    }

    formData.append("Emails", body.emails);
    formData.append("Subject", body.subject);
    formData.append("Message", body.message);

    if (body.followupDemandType) {
        formData.append("FollowUpDemandType", body.followupDemandType.toString());
    }

    body.claimFiles?.forEach((cf) => {
        formData.append('claimFiles', cf.id!.toString());
    });

    body.files?.forEach((file) => {
        formData.append('files', file);
    });

    await fetchApi.post(`${BASE_URL}/send-email/${body.claimId}`, formData);
};

export const loadDocumentFolloupReply = async (body: LoadDocumentFollowUpReplyDto): Promise<void> => {
    const formData = new FormData();

    if (body.files) {
        body.files.forEach(file => {
            formData.append('files', file);
        });
    }
    
    body.claimFiles?.forEach((cf) => {
        formData.append('claimFiles', cf.id!.toString());
    });

    formData.append('message', body.message);
    formData.append('claimId', body.claimId.toString());
    formData.append('professionalId', body.professionalId.toString());

    await fetchApi.post(`${BASE_URL}/save/reply`, formData);
};

export const getClaimFollowUpsByClaimId = async (claimId: number): Promise<ClaimFollowUpItemDto[]> => 
    await fetchApi.get<ClaimFollowUpItemDto[]>(`${BASE_URL}/${claimId}`);